import { render, staticRenderFns } from "./basicsInfo.vue?vue&type=template&id=c5d9feec&scoped=true&"
import script from "./basicsInfo.vue?vue&type=script&lang=js&"
export * from "./basicsInfo.vue?vue&type=script&lang=js&"
import style0 from "./basicsInfo.vue?vue&type=style&index=0&id=c5d9feec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d9feec",
  null
  
)

export default component.exports